import { createContext, useContext } from 'react';
import memoize from 'react-utils/memoize';
import devLogger from 'react-utils/devLogger';
export const defaultDropdownContext = {
  isDropdown: false,
  shouldLogModalWarning: false,
  dropdownStyleOverrides: {},
  buttonStyleOverrides: {}
};
export const DropdownContext = /*#__PURE__*/createContext(defaultDropdownContext);
const {
  Provider
} = DropdownContext;
export { Provider as DropdownContextProvider };
export const useDropdownContext = () => {
  return useContext(DropdownContext);
};
let hasReportedDropdown = false;
export const createPlacementWarning = memoize(componentName => () => {
  if (hasReportedDropdown) return;
  if (window.newrelic) {
    window.newrelic.addPageAction(`componentInDropdown`, {
      componentName
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    devLogger.warn({
      message: `A \`${componentName}\` was rendered within a \`Dropdown\`. Please refactor.`,
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/8857',
      key: `${componentName}-in-dropdown`
    });
  }
});
export const DropdownContextComponent = ({
  componentName
}) => {
  const {
    shouldLogModalWarning
  } = useContext(DropdownContext);
  const memoizedCreatePlacementWarning = createPlacementWarning(componentName);
  if (shouldLogModalWarning) {
    memoizedCreatePlacementWarning();
  }
  return null;
};

// For testing only
export const resetDropdownReporter = () => {
  hasReportedDropdown = false;
};